import { useState, useEffect, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./NewEvent.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { CSSTransition } from 'react-transition-group';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import PotItem from "../../comm/global/components/PotItem";
import { CustomEventManager } from "../../comm/global/CustomEventManager";
import { GameContext } from "../../GameContext";
import * as YStyled from '../../Styleds';
import SelRewildingMode from "../../comm/global/components/SelRewildingMode";
import DateTimeSel from "../../comm/global/components/DateTimeSel";
import MeetPoint from "../../comm/global/components/MeetPoint";
import MapRoute from "./MapRoute";
import apiManager from '../../ApiManager';
import MemberLimit from "../../comm/global/components/MemberLimit";
const customEventManager = new CustomEventManager();
const NewEvent = ({ setModalType, arg, addModalType, set_menuVisiable }) => {
    const [inProp, setInProp] = useState(false);
    const [data, set_data] = useState({
        events_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString(),
        events_date_end: new Date(new Date().getTime() + 48 * 60 * 60 * 1000).toISOString(),
        events_deadline: arg.type==="previous"?new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString():new Date(new Date().getTime() + 72 * 60 * 60 * 1000).toISOString(),
        events_name: "",
        events_lat: "",
        events_lng: "",
        events_meeting_point_lat: "",
        events_meeting_point_lng: "",
        events_meeting_point_name: "",
        events_photo: "",
        events_participant_limit: 0,
        events_participants: "",
        events_payment_fee: 0,
        events_payment_required: 0,
        events_requires_approval: 1,
        events_place: "",//google place id
        events_rewilding: "",//Rewilding ID
        events_type: "",
        events_photo_cover: "DEFAULT_0",
    });
    const [pot, set_pot] = useState(null);
    const [selectedPhotoInd, set_selectedPhotoInd] = useState(0);
    const [photos, set_photos] = useState([
        { type: 0, url: "./assets/cover/0.png", label: "藍天白雲" },
        { type: 0, url: "./assets/cover/1.png", label: "羊羊健行" },
        { type: 0, url: "", label: "上傳照片" },
    ]
    );
    const [step, set_step] = useState(0);
    const stepList = ["建立行程", "編輯首圖", "時間與細節"];
    const [meetPlace, set_meetPlace] = useState({ name: "", lat: "", lng: "" });


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const imageUrl = URL.createObjectURL(file);
        set_photos(props => {
            let _props = [...props];
            _props[2].url = imageUrl;
            _props[2].file = file;
            return _props;
        });
        set_data(prop => { return { ...prop, events_photo: file } })
        set_selectedPhotoInd(2);
    };

    useEffect(() => {
        setInProp(true);
        if (arg.pot) {
            set_pot(arg.pot);
        }
        if (arg.vo) {
            set_data(prev => {
                const _data = { ...prev };
                for (const key in _data) {
                    if (arg.vo.hasOwnProperty(key)) {
                        _data[key] = arg.vo[key];
                    }
                }
                return _data;
            })
        }
        customEventManager.addEventListener("selPot", selPot);
        return () => {
            customEventManager.removeEventListener("selPot", selPot);
        }
    }, [])
    useEffect(() => {
        if (selectedPhotoInd === 0) {
            set_data(prop => { return { ...prop, events_photo_cover: `DEFAULT_0` } })
            set_data(prop => { return { ...prop, events_photo: "" } })
        }
        else if (selectedPhotoInd === 1) {
            set_data(prop => { return { ...prop, events_photo_cover: `DEFAULT_1` } })
            set_data(prop => { return { ...prop, events_photo: "" } })
        }
        else if (selectedPhotoInd === 2) {
            set_data(prop => { return { ...prop, events_photo_cover: "" } })
            set_data(prop => { return { ...prop, events_photo: photos[2].file } })
        }
    }, [selectedPhotoInd])
    useEffect(() => {
        if (pot) {
            console.log("pot", pot);

            set_data(prev => {
                const data = { ...prev };
                if (pot.rewilding_place_id === "") {
                    data.events_lat = pot.rewilding_lat;
                    data.events_lng = pot.rewilding_lng;
                    data.events_rewilding = pot.rewilding_id;
                }
                else {
                    data.events_lat = pot.rewilding_lat;
                    data.events_lng = pot.rewilding_lng;
                    data.events_place = pot.rewilding_place_id;
                }
                return data;
            })

        }
    }, [pot])
    useEffect(() => {
        console.log("=========meetPlace", meetPlace)
        if (meetPlace) {
            set_data(prev => {
                const data = { ...prev };
                data.events_meeting_point_lat = meetPlace.lat;
                data.events_meeting_point_lng = meetPlace.lng;
                data.events_meeting_point_name = meetPlace.name;
                return data;
            })
        }
    }, [meetPlace]);
    const selPot = async (pot) => {
        //刪掉在此modal之後的所有modal
        addModalType({ cmd: "delAfter", cls: "NewEvent" });
        set_pot(pot);
    }

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "NewEvent"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <IconButton onClick={e => {
                                        if (step === 0)
                                            addModalType({
                                                cls: "AlertCustom", arg: {
                                                    title: "放棄已建立的行程內容？",
                                                    desc: "捨棄後行程將無法復原。",
                                                    options: [
                                                        {
                                                            label: "繼續編輯", cb: () => {

                                                            }
                                                        },
                                                        {
                                                            label: "捨棄行程", cb: () => {
                                                                setInProp(false);
                                                                set_menuVisiable(true)
                                                            }
                                                        },
                                                    ],
                                                }
                                            })
                                        else {
                                            set_step(props => {
                                                props = props - 1;
                                                return props;
                                            })
                                        }
                                    }}>
                                        <ArrowBackIosNewIcon />
                                    </IconButton>
                                </div>
                                <div className={styleUi.stepBar}>
                                    {stepList.map((v, k) => {
                                        let lightStyle = "";
                                        if (step > k)
                                            lightStyle = styleUi.lightAll;
                                        else if (step === k)
                                            lightStyle = styleUi.lightLeft;

                                        return <div key={k} className={`${styleUi.stepItem} ${lightStyle}`}>
                                            <div className={styleUi.stepLine}>
                                                <div className={styleUi.leftLine}>
                                                </div>
                                                <div className={styleUi.rightLine}>
                                                </div>
                                                <div className={styleUi.numLabel}>
                                                    <span>{(k + 1)}</span>
                                                </div>
                                            </div>
                                            <div className={styleUi.label}>
                                                <span>{v}</span>
                                            </div>
                                        </div>
                                    })}
                                </div>
                                {step === 0 &&
                                    <div className={styleUi.step1}>
                                        <div className={styleUi.content}>
                                            <YStyled.Row style={{ marginTop: "1.4rem", marginBottom: "1.4rem" }}>
                                                <YStyled.Span size={17} >行程名稱</YStyled.Span>
                                            </YStyled.Row>
                                            <YStyled.Label style={{ padding: ".1rem" }}>
                                                <YStyled.Input
                                                    value={data.events_name}
                                                    className={styleUi.name}
                                                    size={17}
                                                    placeholder={"舉例：劍潭山沒有潭也沒有劍"}
                                                    onChange={e => {
                                                        let value = e.target.value;

                                                        // 只允許中文、英文字母（大小寫）、數字
                                                        value = value.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, "");

                                                        // 限制最多 20 個字元
                                                        if (value.length > 20) {
                                                            value = value.slice(0, 20);
                                                        }

                                                        set_data(prop => ({ ...prop, events_name: value }));
                                                    }}
                                                />

                                            </YStyled.Label>
                                            <YStyled.Row style={{ marginTop: "1.4rem", marginBottom: "1.4rem" }}>
                                                <YStyled.Span size={17} >地點</YStyled.Span>
                                            </YStyled.Row>
                                            {pot ?
                                                <div className={styleUi.potBox}>
                                                    <PotItem data={pot} />
                                                    <img src="./assets/ui/x.png" onClick={e => {
                                                        set_pot(null)
                                                    }} />
                                                </div>
                                                :
                                                <div className={styleUi.location} onClick={e => {
                                                    addModalType({
                                                        cls: "SelectPot", arg: {
                                                            cb: (sel) => {
                                                                if (sel === "formMap") {
                                                                    addModalType({
                                                                        cls: "SearchMapModal", arg: {
                                                                            cb: (pot) => {
                                                                                console.log("pot", pot)
                                                                                set_pot(pot);
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                else if (sel === "exitsList") {
                                                                    addModalType({
                                                                        cls: "OpenPotList", arg: {
                                                                            cb: () => {
                                                                            },
                                                                            type: "selPot"
                                                                        }
                                                                    })
                                                                }
                                                            }
                                                        }
                                                    })
                                                }}>
                                                    <img src="./assets/ui/Location_b.png"></img>
                                                    <YStyled.Span size={17} fontWeight={400}>加入地點</YStyled.Span>
                                                </div>
                                            }
                                            <YStyled.Row style={{ marginTop: "1.4rem", marginBottom: "1.4rem" }}>
                                                <YStyled.Span size={17} >野放模式</YStyled.Span>
                                            </YStyled.Row>
                                            <SelRewildingMode onSelect={typeObj => {
                                                console.log(typeObj)
                                                set_photos(prev => {
                                                    const _photos = [...prev];
                                                    _photos[1] = { type: typeObj.type, url: typeObj.cover, label: typeObj.label };
                                                    return _photos;
                                                })
                                                set_data(prop => { return { ...prop, events_type: typeObj.id } })
                                            }} />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <YStyled.BTN3 disabled={!(data.events_name && pot)} style={{ position: "fixed", bottom: "1rem", borderRadius: "1rem", padding: "1rem", width: "calc(100% - 2rem)" ,zIndex:"100"}} onClick={e => {
                                                set_step(props => {
                                                    props = props + 1;
                                                    if (props >= stepList.length)
                                                        props = 0;
                                                    return props;
                                                })
                                            }}>
                                                <YStyled.Span size={15}>下一步</YStyled.Span>
                                            </YStyled.BTN3>
                                        </div>
                                    </div>
                                }
                                {step === 1 &&
                                    <div className={styleUi.step2}>
                                        <div className={styleUi.previewBox}>
                                            <img src={photos[selectedPhotoInd].url} />
                                            <div>
                                                <div></div>
                                            </div>
                                        </div>
                                        <div className={styleUi.bgList}>
                                            {photos.map((v, k) => {
                                                if (v.url !== "")
                                                    return <div key={k} className={`${styleUi.imgBox} ${selectedPhotoInd === k ? styleUi.selected : ""}`} onClick={e => {
                                                        set_selectedPhotoInd(k);
                                                    }}>
                                                        <img src={v.url} className={`${styleUi.photo}`} />
                                                        <span>{v.label}</span>
                                                        {
                                                            k === 2 &&
                                                            <div className={`${styleUi.removePhoto}`} onClick={e => {
                                                                e.stopPropagation()
                                                                set_photos(props => {
                                                                    let _props = [...props];
                                                                    _props[2].url = "";
                                                                    _props[2].file = null;
                                                                    return _props;
                                                                });
                                                                set_selectedPhotoInd(0);
                                                            }}>
                                                                <img src="./assets/ui/x.png" />
                                                            </div>
                                                        }
                                                    </div>
                                                else
                                                    return <label key={k} className={styleUi.newPhoto}>
                                                        <div>
                                                            <img src="./assets/ui/Increment.png" />
                                                        </div>
                                                        <span>上傳照片</span>
                                                        <input type="file" accept="image/*" onChange={e => { handleFileChange(e) }} />
                                                    </label>
                                            })}
                                        </div>
                                        <YStyled.BTN3 /* disabled={!(data.events_photo)} */ style={{ position: "fixed", bottom: "1rem", borderRadius: "1rem", padding: "1rem", width: "calc(100% - 2rem)" }} onClick={e => {
                                            set_step(props => {
                                                props = props + 1;
                                                if (props >= stepList.length)
                                                    props = 0;
                                                return props;
                                            })
                                        }}>
                                            <YStyled.Span size={15}>下一步</YStyled.Span>
                                        </YStyled.BTN3>
                                    </div>
                                }
                                {step === 2 &&
                                    <div className={styleUi.step3}>
                                        <div className={styleUi.content}>
                                            <YStyled.VPanel align="center" style={{ marginTop: "1rem" }}>
                                                <DateTimeSel label={"開始"} initDate={new Date(data.events_date)} onSelect={date => {
                                                    set_data(prop => { return { ...prop, events_date: date.toISOString() } })
                                                }} />
                                                <YStyled.Hr height=".5rem" />
                                                <DateTimeSel label={"結束"} initDate={new Date(data.events_date_end)} onSelect={date => {
                                                    set_data(prop => { return { ...prop, events_date_end: date.toISOString() } })
                                                }} />
                                            </YStyled.VPanel>
                                            {arg.type !== "previous" &&
                                                <YStyled.VPanel align="center" style={{ marginTop: "1rem" }}>
                                                    <DateTimeSel timeEnabled={false} initDate={new Date(data.events_deadline)} label={"報名截止日"} onSelect={date => {
                                                        set_data(prop => { return { ...prop, events_deadline: date.toISOString() } })
                                                    }} />
                                                    {/* <YStyled.Hr height=".5rem" /> */}
                                                    {/* <YStyled.Row align="space-between">
                                                <YStyled.Span size={17} fontWeight={0}>費用</YStyled.Span>
                                                <YStyled.Row gap=".4rem" align="center" style={{ width: "auto" }}>
                                                    <YStyled.Label style={{ background: "#F8F8F8", padding: ".4rem 2rem" }}>
                                                        <YStyled.Input defaultValue={800} size={17} style={{ width: "4rem", textAlign: "center" }}></YStyled.Input>
                                                    </YStyled.Label>
                                                    <YStyled.Span size={17}>元</YStyled.Span>
                                                </YStyled.Row>
                                            </YStyled.Row> */}
                                                </YStyled.VPanel>
                                            }
                                            <MemberLimit data={data} set_data={set_data} />
                                            <YStyled.Row style={{ margin: "1.4rem 0 1rem 0" }}>
                                                <YStyled.Span size={17} >集合點</YStyled.Span>
                                            </YStyled.Row>
                                            <MeetPoint meetPlace={meetPlace} set_meetPlace={set_meetPlace} rewildingObj={pot} type={0} />
                                            <YStyled.RoundedDiv style={{ width: "100%", marginTop: "1rem" }}>
                                                <MapRoute origin={meetPlace} destination={{ lat: data.events_lat, lng: data.events_lng }} showBtn={true} />
                                            </YStyled.RoundedDiv>
                                            <button className={`${allStyle.btnBlack2} ${styleUi.next}`} onClick={e => {
                                                var formdata = new FormData();
                                                for (var k in data) {
                                                    formdata.append(k, data[k]);
                                                }
                                                console.log("data", data)
                                                const fnArr = {}
                                                addModalType({
                                                    cls: "Loading", arg: { fnArr: fnArr }
                                                })
                                                apiManager.fetchPostForm("event", formdata).then(res => {
                                                    fnArr.doCloseFn();
                                                    console.log(res);
                                                    if (res.message) {
                                                        alert(res.message);
                                                    }
                                                    else {
                                                        setInProp(false);
                                                        arg.cb("new")
                                                    }
                                                }).catch(err => {
                                                    fnArr.doCloseFn();
                                                    console.error(err);
                                                    alert(err);
                                                });
                                            }}>
                                                建立
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(NewEvent);